import type { MetaObject } from 'nuxt/schema';

export const useWebsiteHead = (head: MetaObject) => {
  const runtimeConfig = useRuntimeConfig();
  const pageTitlePrefix = runtimeConfig.public.pageTitlePrefix as string;
  const { title } = head;
  useHead({
    ...head,
    title: title ? `${pageTitlePrefix} - ${title}` : pageTitlePrefix,
  });
};
